/*============================================================================================
	  Object Fit Images
=============================================================================================*/
//

var __bnr_close_flg = false;
jQuery(document).ready(function($){
	/*============================================================================================
		  Common
	=============================================================================================*/
	/*    Hamburger Menu
	=====================================================*/
	$('.g_hmb').on('click',function(){
		if($(this).hasClass('active')){
			$(this).removeClass('active');
			$('body').removeClass('open');
			$('#js_menu_contents').removeClass('open');
			$('#js_menu_nav').removeClass('open');
			$('#js_menu_overlay').removeClass('open');
			$('.g_hmb').fadeIn();
		} else {
			$(this).addClass('active');
			$('body').addClass('open');
			$('#js_menu_contents').addClass('open');
			$('#js_menu_nav').addClass('open');
			$('#js_menu_overlay').addClass('open');
			$('.g_hmb').fadeOut();
//			$('.FooterFloat').fadeOut();
			$('.PageTop').fadeOut();
		}
	});
	$('#js_menu_overlay').on('click',function(){
		if($(this).hasClass('open')){
			$(this).removeClass('open');
			$('body').removeClass('open');
			$('.g_hmb').removeClass('active');
			$('#js_menu_contents').removeClass('open');
			$('#js_menu_nav').removeClass('open');
			$('.g_hmb').fadeIn();
		}
	});
	$('.Navi_close').on('click',function(){
		if($('#js_menu_overlay').hasClass('open')){
			$('body').removeClass('open');
			$('#js_menu_overlay').removeClass('open');
			$('.g_hmb').removeClass('active');
			$('#js_menu_contents').removeClass('open');
			$('#js_menu_nav').removeClass('open');
			$('.g_hmb').fadeIn();
		}
	});
	$('.js_bnr_close').click(function () {
		$('.w_SickyBnr').fadeOut();
		__bnr_close_flg = true;
	});

	/*    Scroll Control
	=====================================================*/
	var pos = 0;
	$(window).scroll(function () {
		if(!$('#js_menu_nav').hasClass('open')){
			if (window.matchMedia( "(max-width: 959px)" ).matches) {
				if ($(this).scrollTop() > 100) {
					$('.w_Head').addClass('scroll');
					$('.FooterFloat').fadeIn();
					$('.PageTop').fadeIn();
				} else {
					$('.w_Head').removeClass('scroll');
					$('.FooterFloat').fadeOut();
					$('.PageTop').fadeOut();
//					$('body').focus();
				}

//				if (pos != 0 && $(this).scrollTop() > $('.w_Head').outerHeight()) {
//					if($(this).scrollTop() < pos ){
//						// 上スクロール
//						$('.w_Head').fadeIn();
//					}else{
//						// 下
//						$('.w_Head').fadeOut();
//					}
//				} else {
//					$('.w_Head').fadeIn();
//				}
//				pos = $(this).scrollTop();

			} else {
				if ($(this).scrollTop() > 100) {
					$('.w_Head').addClass('scroll');
					$('.PageTop').fadeIn();
				} else {
					$('.w_Head').removeClass('scroll');
					$('.PageTop').fadeOut();
//					$('.PageTop a').blur();
//					console.log('2');
				}
			}
		}

		var docHeight = $(document).innerHeight();
		var windowHeight = $(window).innerHeight();
		var pageBottom = docHeight - windowHeight;
		pageBottom = pageBottom * 0.95;
		if ($(this).scrollTop() < pageBottom) {
			$('.PageTop').removeClass('page_btm');
		} else {
			$('.PageTop').addClass('page_btm');
		}
//		if ($('.w_TopHead').length > 0) {
//			if ($(this).scrollTop() < ($('.w_TopHead').outerHeight() / 2)) {
//				$('.w_SickyBnr').fadeOut();
//				console.log('out');
//			} else if ($(this).scrollTop() < pageBottom) {
//				if (!__bnr_close_flg) {
//					$('.w_SickyBnr').fadeIn();
//					console.log('in');
//				}
//			} else {
//				if (window.matchMedia( "(max-width: 959px)" ).matches) {
//					$('.w_SickyBnr').fadeOut();
//					console.log('hide');
//				}
//			}
//		} else {
//			if ($(this).scrollTop() < ($('.w_PageHead').outerHeight() / 2)) {
//				$('.w_SickyBnr').fadeOut();
//			} else if ($(this).scrollTop() < pageBottom) {
//				if (!__bnr_close_flg) {
//					$('.w_SickyBnr').fadeIn();
//				}
//			} else {
//				if (window.matchMedia( "(max-width: 959px)" ).matches) {
//					$('.w_SickyBnr').fadeOut();
//				}
//			}
//		}
	});

	/*    Anchor Link
	=====================================================*/

	$('a[href^="#"]').click(function(){
		
		var speed = 500;
		var href= $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		var position = target.offset().top;
		
//		if (href == '#contact') {
//			position = position - 46;
//		}
//		if (window.matchMedia( "(min-width: 960px)" ).matches) {
			position = position - $('.w_Head').outerHeight();
//		}
		$("html, body").animate({scrollTop:position}, speed, "swing");
		if($('#js_menu_overlay').hasClass('open')){
			$(".NaviSp_close").trigger('click');
		}
		return false;
	});

	// ページ内アンカーリンク設定
	$('a[href*="#"]').click(function(){
		var speed = 500;
		var href= $(this).attr("href");
		var home = location.origin + '/';
		href = href.replace(home, "");
		href = href.replace('wp/', "");
		console.log(href);
		if (href.slice(0,1) == '#' || href == "") {
			var target = $(href == "#" || href == "" ? 'html' : href);
			var position = target.offset().top;
//			if (window.matchMedia( "(min-width: 960px)" ).matches) {
				position = position - $('.w_Head').outerHeight();
//			}
			$("html, body").animate({scrollTop:position}, speed, "swing");
			if($('#js_menu_overlay').hasClass('open')){
				$(".NaviSp_close").trigger('click');
			}
			return false;
		}
	});

	//別ページからのアンカーリンク設定
	$(window).on('load',function (e) {
		var speed = 500;
		//アンカーリンク取得
		var hash = location.hash;
		//アンカーリンクがあった場合
		if($(hash).length){
			e.preventDefault();
			//アンカーリンクの位置取得
			var position = $(hash).offset().top;
//			if (window.matchMedia( "(min-width: 960px)" ).matches) {
				position = position - $('.w_Head').outerHeight();
//			}
			//アンカーリンクの位置まで移動
			$("html, body").animate({scrollTop:position}, speed, "swing");
			$("html, body").scrollTop(position);
		}
	});
	
	/*    Navi Menu
	=====================================================*/
	$('.js_navi_menu').each(function(){
		$(this).on('click',function(){
			$(this).toggleClass('open');
			$("+.Footer_lst",this).slideToggle();
			$("+.Navi_lst",this).slideToggle();
			return false;
		});
	});


});



document.addEventListener("DOMContentLoaded", function() {
	const mainImage = document.querySelector(".product_img img");
	const smallImages = document.querySelectorAll(".product_img_lst img");
	smallImages.forEach(function(smallImage) {
	  smallImage.addEventListener("mouseenter", function() {
		mainImage.src = smallImage.dataset.src;
	  });
  
	  smallImage.addEventListener("click", function() {
		mainImage.src = smallImage.dataset.src;
	  });
	});
  });
  

